import React, { useEffect } from "react";
import { Table } from "antd";
import { ColumnsType } from "antd/es/table";
import { useBillModel } from "./billModel";
import { IBillDetail } from "../../../../../bill/BillTypes";
import { useDetailModel } from "../detailModel";
import { billStatusRender, ioFlagRender } from "@/types/FmsRender";
import { TradeTypeEnum } from "@/types/FmsEnums";



export function BillDataTable() {
    const {
        dataSource, selectedRowKeys, pgCfg, selectedData,
        loadData, setSelectedRowKeys, setSelectedData
    } = useBillModel();

    const {
        payMethodLabels,
    } = useDetailModel()
    const columns: ColumnsType<IBillDetail> = [
        {
            align: "center",
            width: 60,
            // ellipsis: true,
            title: '序号',
            fixed: "left",
            render: (v, r, i) => i + 1
        },
        {
            align: "center",
            width: 200,
            title: '单据编号',
            dataIndex: 'tradeCode',
        },
        {
            align: "center",
            title: '供应商名称',
            dataIndex: 'partnerName',
        },
        {
            align: "center",
            title: '单据金额',
            dataIndex: 'billAmount',
            render: (text, record) => (
                record.tradeTypeCode as any === TradeTypeEnum.SALE_RETURN ||
                record.tradeTypeCode as any === TradeTypeEnum.PURCHASE_RETURN) ? Math.abs(text) : text
        },
        {
            align: "center",
            title: '支付类型',
            dataIndex: 'payType',
            render: v => payMethodLabels[v] ?? '暂无'
        },
        {
            align: "center",
            title: '备注',
            dataIndex: 'note',
        },
        {
            align: "center",
            width: 100,
            // ellipsis: true,
            title: '账户类型',
            dataIndex: 'accountTypeName',
        },
        {
            align: "center",
            title: '分支',
            dataIndex: 'branch',
        },
        {
            align: "center",
            title: '单据类型',
            dataIndex: 'tradeTypeName',
        },
        {
            align: "center",
            title: '优惠类型',
            dataIndex: 'preferentialTypeName',
            render: v => v ?? '暂无'
        },
        {
            align: "center",
            title: '账单编码',
            dataIndex: 'code',
        },
        {
            align: "center",
            title: '账户名称',
            dataIndex: 'accountName',
        },
        {
            align: "center",
            title: '实体',
            dataIndex: 'beName',
        },
        {
            align: "center",
            title: '收支类型',
            dataIndex: 'ioFlag',
            render: ioFlagRender
        },
        {
            align: "center",
            title: '收款状态',
            dataIndex: 'status',
            render: billStatusRender
        },
        {
            align: "center",
            title: '从属机构',
            dataIndex: 'orgName',
        },
        {
            align: "center",
            title: '记账日期',
            dataIndex: 'createTime',
        },
        {
            align: "center",
            title: '业务员',
            dataIndex: 'tradeOperator',
        },
        {
            align: "center",
            title: '核销日期',
            dataIndex: 'writeoffTime',
        },
        {
            align: "center",
            title: '核销人',
            dataIndex: 'writeoffUser',
        },
        {
            align: "center",
            title: '取消状态',
            dataIndex: 'cancelStatus',
            render: (v) => v === 0 ? '初始' : v === 1 ? '审核中' : v === 2 ? '已取消' : v === 9 ? '异常 ' : ''
        },
    ];

    return (
        <Table
            bordered
            rowSelection={{
                type: "checkbox",
                onChange: (selectedRowKeys: React.Key[], selectedRows: IBillDetail[]) => {
                    setSelectedRowKeys(selectedRowKeys);
                    setSelectedData(selectedRows)
                },
                selectedRowKeys
            }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                position: ["bottomCenter"],
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize }).then();
                }
            }}
            onRow={record => {
                return {
                    onClick: event => {
                        if (selectedRowKeys.length > 0 && selectedRowKeys[0] === record.key) {
                            setSelectedRowKeys(arr => arr.filter(item => item !== record.key));
                            setSelectedData(arr => arr.filter(item => item.key !== record.key))
                        } else {
                            setSelectedRowKeys([...selectedRowKeys, record.key]);
                            setSelectedData([...selectedData, record])
                        }
                    },
                };
            }}
            scroll={{ x: 'max-content' }}
        />
    )
}
